// src/lib/kinema/core/layers/treeUtils.ts
import type { BaseLayerData } from '../types';

type LayerMap = Record<string, BaseLayerData>;

/**
 * Get the top-level layers (children of the root composition).
 * Pass the rootLayerId from EditorState.
 */
export function getRootLayers(layers: LayerMap, rootLayerId?: string): BaseLayerData[] {
  if (rootLayerId) {
    return getChildren(layers, rootLayerId);
  }
  // Fallback: layers with parentId === null (excluding the root comp itself)
  return Object.values(layers)
    .filter((l) => l.parentId === null && l.type !== 'composition')
    .sort((a, b) => a.order - b.order);
}

export function getChildren(layers: LayerMap, parentId: string): BaseLayerData[] {
  return Object.values(layers)
    .filter((l) => l.parentId === parentId)
    .sort((a, b) => a.order - b.order);
}

export function getAncestors(layers: LayerMap, layerId: string): BaseLayerData[] {
  const result: BaseLayerData[] = [];
  let current = layers[layerId];
  while (current?.parentId) {
    const parent = layers[current.parentId];
    if (!parent) break;
    result.push(parent);
    current = parent;
  }
  return result;
}

export function getDescendants(layers: LayerMap, parentId: string): BaseLayerData[] {
  const result: BaseLayerData[] = [];
  const children = getChildren(layers, parentId);
  for (const child of children) {
    result.push(child);
    result.push(...getDescendants(layers, child.id));
  }
  return result;
}
